import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ChevronLeft, Download } from "lucide-react";
import { api } from "../api";
import { useNurserySettings } from "../SettingsContext";

/**
 * Public /terms — download/view the Terms & Conditions PDFs in both English
 * and Nederlands. Linked from the storefront footer, login page and
 * registration page.
 */
export default function Terms() {
  const { nurseryName } = useNurserySettings();
  const [data, setData] = useState({ version: "2026-10", languages: [] });

  useEffect(() => {
    api.get("/terms").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const abs = (path) => {
    const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
    return `${base}${path}`;
  };

  return (
    <div className="min-h-screen bg-[#F9F9F8] p-6">
      <div className="max-w-2xl mx-auto">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs text-[#5C665A] hover:text-[#1A1D1A] mb-4" data-testid="terms-back">
          <ChevronLeft size={12} /> Back
        </Link>
        <div className="bg-white border border-[#E2E4E0] rounded-xl p-6 shadow-sm">
          <div className="db-h mb-5">
            <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
              <FileText size={22} /> General Sales and Delivery Terms
            </h1>
            <p className="text-sm text-[#5C665A] mt-1">
              {nurseryName || "Florali Licensing B.V."} — version <span className="db-mono">{data.version}</span>
            </p>
          </div>
          <p className="text-sm text-[#5C665A] leading-relaxed mb-6">
            Our general terms govern all orders. Please review before placing
            an order. The authoritative text is the Dutch original;
            the English version is a translation provided for convenience.
          </p>
          <div className="space-y-2" data-testid="terms-lang-list">
            {data.languages.map((l) => (
              <div
                key={l.code}
                className="flex items-center justify-between border border-[#E2E4E0] rounded-md px-3 py-2"
                data-testid={`terms-lang-${l.code}`}
              >
                <div>
                  <div className="font-medium">{l.label}</div>
                  <div className="text-xs text-[#5C665A] db-mono">terms_{l.code}.pdf</div>
                </div>
                <div className="flex gap-2">
                  <a
                    href={abs(l.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#1B4332] underline underline-offset-2 hover:no-underline"
                    data-testid={`terms-view-${l.code}`}
                  >
                    View
                  </a>
                  <a
                    href={abs(l.url)}
                    download
                    className="inline-flex items-center gap-1 text-sm text-[#1B4332] underline underline-offset-2 hover:no-underline"
                    data-testid={`terms-download-${l.code}`}
                  >
                    <Download size={12} /> Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
